import { Navigate } from 'react-router';
import { inferRouteObject } from 'react-router-typed-object';

import { or, PrivateRoute, Roles } from '@/js/libs/use-auth';

import AppConfig from 'src/scenes/AppConfig';
import Status from 'src/scenes/Status';

const index = true;

export const appConfigRouteObject = inferRouteObject({
  path: 'app-config',
  element: <PrivateRoute roles={or(Roles.ADMIN, Roles.HEADER_TAG)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: AppConfig.Helmet,
      children: [
        {
          index,
          element: <Navigate to='./publishers' replace />,
        },
        {
          path: 'publishers',
          children: [
            { index, Component: AppConfig.PublishersList },
            { path: 'create', Component: AppConfig.PublisherForm },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                { path: ':publisherId', Component: AppConfig.PublisherForm },
              ],
            },
            {
              path: ':publisherId',
              children: [
                { index, Component: AppConfig.PublisherDetails },
                {
                  path: 'ad-config',
                  children: [
                    {
                      index,
                      Component: AppConfig.AdConfigForm,
                    },
                    {
                      path: ':adConfigId',
                      Component: AppConfig.AdConfigForm,
                    },
                  ],
                },
              ],
            },
          ],
        },
        { path: '*', element: <Navigate to='./publishers' replace /> },
      ],
    },
  ],
});
